import Products from './ProductsContainer';

export default Products;
